import { Pipe, PipeTransform } from '@angular/core';
import { SoilDescriptionType } from '@services/cleanfill-api/cleanfill-api.generated';

@Pipe({
  name: 'soilDescriptionType'
})
export class SoilDescriptionTypePipe implements PipeTransform {
  transform(value: SoilDescriptionType): string {
    return this.getLabel(value);
  }

  getLabel(soilDescriptionType: SoilDescriptionType): string {
    switch (soilDescriptionType) {
      case SoilDescriptionType.Clay:
        return 'Clay';
      case SoilDescriptionType.Sand:
        return 'Sand';
      case SoilDescriptionType.Topsoil:
        return 'Topsoil';
      case SoilDescriptionType.Granular:
        return 'Granular';
      case SoilDescriptionType.MixedSiltyClayWithTraceGravelSand:
        return 'Mixed - Silty Clay With Trace of Gravel or Sand';
      case SoilDescriptionType.TopsoilwithTraceGravelSand:
        return 'Topsoil With Trace of Gravel or Sand';
      case SoilDescriptionType.SandySilt:
        return 'Sandy Silt';
      case SoilDescriptionType.Shale:
        return 'Shale';
      case SoilDescriptionType.MixedClaySiltsShale:
        return 'Mixed Clay, Silts or Shale';
      case SoilDescriptionType.BrickBlockRubble:
        return 'Brick, Block, or Rubble';
      case SoilDescriptionType.CleanFill:
        return 'Cleanfill';
      case SoilDescriptionType.AsphaltMix:
        return 'Asphalt Mix';
      default:
        return '';
    }
  }
}
